import React, { useEffect, useState } from 'react';
import { IListItem } from '../_Core/CoreTypes';
import { IIdMapping } from './PromotionTypes';
import Button from '../_Core/Button';

interface IProps {
  sourceList: IListItem[];
  destinationList: IListItem[];
  mappingKey: IIdMapping[];
  UpdatedMap: (newMap: IIdMapping[]) => void;
}

const Mapper = (props: IProps) => {
  const [map, setMap] = useState<IIdMapping[]>([]);

  useEffect(() => {
    if (!props.mappingKey || props.mappingKey.length === 0) {
      //updated lists see if we can auto map some items.
      // If the name is the same...
      let newMap: IIdMapping[] = [];
      props.sourceList.forEach((sourceItem) => {
        const matchingDest = props.destinationList.find((destItem) => destItem.name === sourceItem.name);
        if (matchingDest) {
          newMap.push({ OldId: sourceItem.id, NewId: matchingDest.id });
        }
      });
      setMap(newMap);
      //props.UpdatedMap(newMap);
    } else {
      setMap(props.mappingKey);
    }
    //only run this on initial load
  }, []);

  const updateMap = (sourceId: string, destinationId: string) => {
    let newMap = [...map];
    const mapIndex = newMap.findIndex((m) => m.OldId === sourceId);
    if (mapIndex >= 0) {
      newMap[mapIndex].NewId = destinationId;
    } else {
      newMap.push({ OldId: sourceId, NewId: destinationId });
    }

    setMap(newMap);
    //don't update parent until they click the button
    //props.UpdatedMap(newMap);
  };

  return (
    <>
      <div className="mapper">
        <div className="form-group">
          <label className="control-label col-sm-4">Source Item</label>
          <div className="col-sm-8">
            <div className="form-control">Mapped To</div>
          </div>
        </div>
        {props.sourceList.map((item) => (          
          <div key={item.id} className="form-group">
            <label className="control-label col-sm-4">{item.name}</label>
            <div className="col-sm-8">
              <select className={`form-control ${map.find((m) => m.OldId === item.id) ? 'mapped' : 'not-mapped'}`} onChange={(e) => updateMap(item.id, e.target.value)} 

              value={map.find((m) => m.OldId === item.id)?.NewId || ''}>
                <option value="">Select a match (NOT MAPPED)</option>
                {props.destinationList.map((dest) => (
                  <option key={dest.id} value={dest.id}>
                    {dest.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ))}
      </div>
      
        <div className="form-group">
          <div className="col-sm-8 col-sm-offset-4">
            <br/>
            
            <Button type="next" text="Set & Next" addClass='btn-primary' onClick={()=>{
                console.log(map);
                props.UpdatedMap(map);
            }}/>
          </div>
        </div>
    </>
  );
};

export default Mapper;
